( function( app ) {
  const COMPONENT = {
    init: function() {
      const images = [];
      let currentImages0 = [];
      let currentImages1 = [];

      $( '.soldiers-callout .images img' ).each( function() {
        images.push( $( this ).attr( 'src' ) );
      } );

      function generateImageSrc( wrapperIndex ) {
        const maxAttempts = images.length * 3;

        if ( wrapperIndex == 0 ) {
          let image;
          let attempts = 0;

          do {
            image = images[Math.floor( Math.random() * images.length )];
            attempts++;
          } while ( $.inArray( image, currentImages0 ) !== -1 && attempts < maxAttempts );

          currentImages0.push( image );
          return image;
        } else if ( wrapperIndex == 1 ) {
          let image;
          let attempts = 0;

          do {
            image = images[Math.floor( Math.random() * images.length )];
            attempts++;
          } while ( $.inArray( image, currentImages1 ) !== -1 && attempts < maxAttempts );

          currentImages1.push( image );
          return image;
        }
      }

      $( '.soldiers-callout .soldiers-callout__stars--0' ).find( '.svg-wrapper' ).each( function( svgWrapperIndex, svgWrapper ) {
        $( svgWrapper ).find( 'img' ).attr( 'src', generateImageSrc( 0 ) );
      } );

      $( '.soldiers-callout .soldiers-callout__stars--1' ).find( '.svg-wrapper' ).each( function( svgWrapperIndex, svgWrapper ) {
        $( svgWrapper ).find( 'img' ).attr( 'src', generateImageSrc( 1 ) );
      } );

      mainAnimation();

      let timer = null;
      let running = false;

      function mainAnimation() {
        currentImages0 = [];
        currentImages1 = [];

        setTimeout( function() {
          $( '.soldiers-callout .soldiers-callout__stars--0' ).addClass( 'opacity-0' );
        }, 1000 );

        setTimeout( function() {
          $( '.soldiers-callout .soldiers-callout__stars--0' ).find( '.svg-wrapper' ).each( function( svgWrapperIndex, svgWrapper ) {
            $( svgWrapper ).find( 'img' ).attr( 'src', generateImageSrc( 0 ) );
          } );
        }, 2000 );

        setTimeout( function() {
          $( '.soldiers-callout .soldiers-callout__stars--0' ).removeClass( 'opacity-0' );
        }, 3000 );

        setTimeout( function() {
          $( '.soldiers-callout .soldiers-callout__stars--1' ).find( '.svg-wrapper' ).each( function( svgWrapperIndex, svgWrapper ) {
            $( svgWrapper ).find( 'img' ).attr( 'src', generateImageSrc( 1 ) );
          } );
        }, 4000 );
      }

      function step() {
        mainAnimation();
      }

      function start() {
        $( '.soldiers-callout__toggle-animation' ).attr( 'title', 'Pause animation' );
        $( '.soldiers-callout__toggle-animation .icon-pause-loop' ).show();
        $( '.soldiers-callout__toggle-animation .icon-play-loop' ).hide();

        if ( timer ) return; // prevent double-starting
        timer = setInterval( step, 5000 );
        running = true;
      }

      function pause() {
        $( '.soldiers-callout__toggle-animation' ).attr( 'title', 'Play animation' );
        $( '.soldiers-callout__toggle-animation .icon-pause-loop' ).hide();
        $( '.soldiers-callout__toggle-animation .icon-play-loop' ).show();
        clearInterval( timer );
        timer = null;
        running = false;
      }

      function toggle() {
        running ? pause() : start();
      }

      start();

      $( '.soldiers-callout__toggle-animation' ).on( 'click', function() {
        toggle();
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'soldiers-callout', COMPONENT );
} )( app );
